/* ------------------------------------------------------------------
   DM ARCHIPELAGO — About / Maison page motion.
   Loaded once per page (guarded), re-initialises in the theme editor.
   No styling here: it only toggles the classes the stylesheet expects.
   ------------------------------------------------------------------ */
(function () {
  if (window.__dmaAboutMotion) return;
  window.__dmaAboutMotion = true;

  if (!('IntersectionObserver' in window)) return;

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-in');
      syncGhost(entry.target);
      io.unobserve(entry.target);
    });
  }, { threshold: 0.18, rootMargin: '0px 0px -8% 0px' });

  /* wrap every word in a mask so it can bounce up from below */
  function splitWords(el) {
    if (el.hasAttribute('data-words-ready')) return;
    el.setAttribute('data-words-ready', '');

    var step = parseInt(el.getAttribute('data-stagger') || 55, 10);
    var words = el.textContent.trim().split(/\s+/);
    el.textContent = '';

    words.forEach(function (word, i) {
      var mask = document.createElement('span');
      mask.className = 'dma-w';
      var inner = document.createElement('i');
      inner.textContent = word;
      inner.style.setProperty('--d', (i * step) + 'ms');
      mask.appendChild(inner);
      el.appendChild(mask);
      if (i < words.length - 1) el.appendChild(document.createTextNode(' '));
    });
  }

  /* the overlapping half of MAISON is a duplicate — keep it in step */
  function syncGhost(band) {
    if (!band.classList.contains('dma-masthead')) return;
    var title = band.querySelector('.dma-title');
    var ghost = document.querySelector('.dma-ghost');
    if (!title || !ghost) return;
    ghost.innerHTML = title.innerHTML;
    ghost.classList.add('is-in');
  }

  function init(scope) {
    var ctx = scope || document;

    each(ctx.querySelectorAll('.dma'), function (root) {
      root.classList.add('dma-anim');
    });
    each(ctx.querySelectorAll('[data-delay]'), function (el) {
      el.style.setProperty('--d', el.getAttribute('data-delay') + 'ms');
    });
    each(ctx.querySelectorAll('[data-words]'), splitWords);
    each(ctx.querySelectorAll('[data-reveal]'), function (el) {
      io.observe(el);
    });
  }

  function each(list, fn) {
    Array.prototype.forEach.call(list, fn);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  /* theme editor: a re-rendered section needs its own pass */
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
}());
